<template>
  <div>
    <initiate-shipping-request v-if="!formDetailsExist"></initiate-shipping-request>
    <shipping-request
      :onSave="saveShippingRequest"
      :onSubmit="submitShippingRequest"
      v-if="formDetailsExist"
    ></shipping-request>

    <b-loading :is-full-page="true" :active.sync="isSaving" :can-cancel="false"></b-loading>
    <b-loading :is-full-page="true" :active.sync="isSubmitting" :can-cancel="false"></b-loading>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import ShippingRequest from "@/modules/commonModule/components/createShippingRequest/Main";
import InitiateShippingRequest from "@/modules/shippersModule/components/InitiateShippingRequest";

import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("shippers");
import {
  mapGetters as mapRootGetters,
  mapMutations as mapRootMutations
} from "vuex";
import {
  SHIPPER_MUTATION_TYPES,
  ROOT_MUTATION_TYPES
} from "@/store/mutation-types";

import saveShippingRequestMutation from "@/modules/shippersModule/api/graphql/mutations/SaveShippingRequest";
import submitShippingRequestMutation from "@/modules/shippersModule/api/graphql/mutations/SubmitShippingRequest";
import GetPortsAndDangerousGoodsInfoQuery from "@/modules/commonModule/api/graphql/queries/GetPortsAndDangerousGoodsInfo";

export default {
  name: "NewShippingRequest",

  components: { ShippingRequest, InitiateShippingRequest },

  data() {
    return {
      isSaving: false,
      isSubmitting: false,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      formDetailsExist: "shippingRequestHasBeenInitiated",
      shippingRequest: "getShippingRequest",
      shippingRequestID: "getShippingRequestID",
      dangerousGoodsInfo: "getDangerousGoodsInfo"
    }),
    ...mapRootGetters({
      portsFromVuex: "getPorts"
    })
  },

  mounted() {
    // Load the list of ports from the API
    if (!this.portsFromVuex.loaded || this.dangerousGoodsInfo.length < 1) {
      this.loadApiData();
    }
  },

  methods: {
    ...mapRootMutations({
      updatePorts: ROOT_MUTATION_TYPES.SAVE_PORTS
    }),

    ...mapMutations({
      updateDangerousGoodsInfo:
        SHIPPER_MUTATION_TYPES.SAVE_DANGEROUS_GOODS_INFO,
      resetShippingRequest: SHIPPER_MUTATION_TYPES.RESET_SHIPPING_REQUEST
    }),

    /**
     * Save a shipping request
     */
    saveShippingRequest: function() {
      this.isSaving = true;

      this.$apollo
        .mutate({
          mutation: saveShippingRequestMutation,
          variables: {
            id: this.shippingRequestID,
            data: JSON.stringify(this.shippingRequest)
          }
        })
        .then(response => {
          this.$toast.open({
            duration: 3000,
            message: "Your shipping request has been saved.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "An error occured while trying to save shipping request",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

    /**
     * Submit a shipping request.
     */
    submitShippingRequest: function() {
      this.isSubmitting = true;

      this.$apollo
        .mutate({
          mutation: submitShippingRequestMutation,
          variables: {
            temporary_id: this.shippingRequest.form_details.id,
            reference_number: this.shippingRequest.form_details
              .reference_number,
            shipper_and_consignee_details: this.shippingRequest
              .shipper_and_consignee_details,
            dangerous_goods: this.shippingRequest.dangerous_goods,
            container_details: this.shippingRequest
              .additional_info_and_docs,
            certificate_documents: this.shippingRequest
              .uploaded_certificate_documents,
            shipper_declaration: this.shippingRequest.shipper_declaration
          }
        })
        .then(response => {
          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Your shipping request has been submitted successfully.",
            type: "is-success"
          });
          this.resetShippingRequest();
          this.$router.push({ name: "shippers-application-status" });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message:
              "An error occured while trying to submit the shipping request",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    loadApiData: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsAndDangerousGoodsInfoQuery
        })
        .then(response => {
          const ports = response.data.ports;
          const dangerousGoodsInfo = response.data.DangerousGoodsInfo;
          this.updatePorts(ports);
          this.updateDangerousGoodsInfo(dangerousGoodsInfo);
          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Ports and Dangerous Goods loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "Failed to load list of ports and dangerous good info",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid #ddd;
}
</style>
